import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Slider } from "@mui/material";
import { NepaliDatePicker } from "nepali-calander";
import React, { useState } from "react";
import { axiosPost } from "../../utils/AxiosApi";
import { URL } from "../../utils/Constants";
import { useEffect } from "react";
import moment from "moment";

const FilterStudentModal = ({
  filterData,
  setFilterData,
  classroom,
  handleFilterFormSubmit,
}) => {
  const [academicYears, setAcademicYears] = useState(null);

  useEffect(() => {
    getAcademicYears();
  }, []);

  const getAcademicYears = () => {
    axiosPost(URL.getAllAcademicYears, {}, (response) => {
      if (response.status === 200) {
        const results = response.data.data;
        setAcademicYears(results);
      }
    });
  };

  const classLevel = classroom?.map((item) => ({
    name: item.yearLevelName,
    id: item.yearLevelId,
  }));

  //remove duplicate classlevel
  const filteredClassLevel = classLevel?.filter((obj, index) => {
    return index === classLevel.findIndex((o) => obj.id === o.id);
  });

  const sections = classroom
    ?.filter((item) => item.yearLevelId === parseInt(filterData?.class))
    ?.map((item) => ({ name: item.name, id: item.id }));

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    handleFilterFormSubmit();
  };

  return (
    <form action="" onSubmit={handleFilterSubmit}>
      <div className="filter-modal">
        <div className="filter-input">
          <label htmlFor="class">Class</label>
          <select
            id="class"
            name="class"
            value={filterData?.class}
            onChange={handleChange}
          >
            <option value="">Please select a class</option>
            {filteredClassLevel?.map((item) => (
              <option key={item.id} value={item.id}>
                Class {item.name}
              </option>
            ))}
          </select>
        </div>
        <div
          style={
            filterData?.class
              ? { visibility: "visible" }
              : { visibility: "hidden" }
          }
          className="filter-input"
        >
          <label htmlFor="section">Section</label>
          <select
            id="section"
            name="section"
            value={filterData?.section}
            onChange={handleChange}
          >
            <option value="">Please select a section</option>
            {!filterData?.class ? (
              <option value="">Please select a class first</option>
            ) : (
              sections.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))
            )}
          </select>
        </div>
        <div className="filter-input">
          <label htmlFor="studentName">Student Name</label>
          <input
            type="text"
            name="studentName"
            id="studentName"
            placeholder="Enter a student's name"
            value={filterData?.studentName}
            onChange={handleChange}
          />
        </div>
        <div className="filter-input">
          <label htmlFor="admissionStatus">Admission Status</label>
          <select
            id="admissionStatus"
            name="admissionStatus"
            value={filterData?.admissionStatus}
            onChange={handleChange}
          >
            <option value="">Please select a status</option>
            <option value="ASSIGNED">Assigned</option>
            <option value="UNASSIGNED">Unassigned</option>
          </select>
        </div>
        <div className="filter-input">
          <label htmlFor="gender">Gender</label>
          <select
            id="gender"
            name="gender"
            value={filterData?.gender}
            onChange={handleChange}
          >
            <option value="">Please select a gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="prefer not to say">Prefer not to say</option>
          </select>
        </div>
        <div className="filter-input">
          <label htmlFor="admissionDate">Date of Admission</label>
          <NepaliDatePicker
            className="date"
            placeholder="Select date of admission"
            type="input"
            calendarMode={"ad"}
            showToggle={true}
            showNationalHoliday={false}
            events={[]}
            value={filterData?.admissionDate}
            maxDate={moment(new Date()).format("YYYY-MM-DD")}
            onDateSelect={(date) =>
              setFilterData((prev) => ({
                ...prev,
                admissionDate: date.ad.date,
              }))
            }
            styles={{ width: "100% !important" }}
          />
        </div>
        <div className="filter-input">
          <label htmlFor="academicYear">Academic Year</label>
          <select
            id="academicYear"
            name="academicYear"
            value={filterData?.academicYear}
            onChange={handleChange}
          >
            <option value="">Please select an academic year</option>
            {academicYears?.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
        </div>
        <div className="filter-input age-input">
          <label htmlFor="age">Age Range</label>
          <Slider
            name="age"
            getAriaLabel={() => "age range"}
            valueLabelDisplay="auto"
            value={filterData?.age}
            onChange={handleChange}
          />
          <div className="age-display">
            <span className="age-value">Min Age: {filterData?.age[0]}</span>
            <span className="age-value">Max Age: {filterData?.age[1]}</span>
          </div>
        </div>
        <div className="filter-input">
          <label htmlFor="guardian">Parents / Guardian</label>
          <input
            type="text"
            name="guardian"
            id="guardian"
            placeholder="Enter guardian's name"
            value={filterData?.guardian}
            onChange={handleChange}
          />
        </div>
      </div>
      <button
        type="submit"
        aria-label="filter student"
        className="primary-btn filter-form-btn"
      >
        <FontAwesomeIcon icon={faMagnifyingGlass} />
        <span>Filter</span>
      </button>
    </form>
  );
};

export default FilterStudentModal;
